import { useEffect, useState, useMemo } from "react";
import ReactTableWrapper from "../../components/ReactTableWrapper";
import { exportAsCSV } from "../../utils/CSVExporter";
import { exportAsPDF } from "../../utils/PDFExporter";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import Sidebar from '../../Sidebar';
import Swal from "sweetalert2";
import { useCookies } from 'react-cookie';
import { getAllReceiptVouchers, deleteReceiptVoucher } from "../../services/ReceiptVoucherServices";
import ListFormPageHeader from "../../components/ListFormPageHeader";

function ReceiptVoucherTable() {
    const InitialData = {
        total_pages: 0,
        records: [],
      };
    const [data, setData] = useState(InitialData);
    const navigate = useNavigate(); 
    const [refreshKey, setRefreshKey] = useState(0);
    const [cookies] = useCookies(['myToken']);
    const [isLoading, setIsLoading] = useState(true);  
    const columns = useMemo(
        () => [
            {
                fieldName: "phone_number",
                headerName: 'Receipt Number'
            },
            {
                fieldName: "phone_number",
                headerName: 'Receipt Date'
            },
            {
                fieldName: 'entity_name', 
                headerName: 'Customer Name'
            },
            {
                fieldName: "phone_number",
                headerName: 'Receipt Amount'
            },
           
            {
                fieldName: "address",
                headerName: 'Mode of Receipt'
            },
            {
                fieldName: "address",
                headerName: 'Bank/Cash'
            },
            {
                fieldName: 'entity_name', 
                headerName: 'Marketing Name'
            },
            {
                fieldName: 'status',
                headerName: 'Status',
            },
            {
                fieldName: "id",
                headerName: "ROW_ACTIONS"
            }
        ],
        [],);

    const onEditReceiptVoucher = (receiptId, event) => {
       
       navigate(`/ReceiptVoucherEdit/${receiptId}/`);
    };

    const onDeleteReceiptVoucher = (receiptId, event) => {

        event.preventDefault();
        Swal.fire({title: 'Are you sure to Delete?',  
        showCancelButton: true,  
        confirmButtonText: `Yes`,  
        cancelButtonText: `No`,
        }).then((result) => {  
          if (result.isConfirmed) { 

            setIsLoading(true);
            deleteReceiptVoucher(cookies, receiptId); 
            console.log(`SalesRep with id ${receiptId} deleted`);
            Swal.fire('Deleted Successfully!', '', 'success');
            setRefreshKey(oldKey => oldKey +1)
          } else if (result.isDismissed) {    
            Swal.fire('Not Deleted', '', 'info')  
        }
        });
        //

    };

    const handleCSVExport = (event) => {
        console.log('CSV Export');
        exportAsCSV(
            columns
            .filter(col => col.headerName !== 'ROW_ACTIONS')
            .map(c => c.headerName),
            data.records.map(r => {

                const csvRow = {
                    entity_name: r.entity_name,
                    address: r.address,
                    phone_number:r.phone_number,
                    mobile_number:r.mobile_number,
                    status:r.status
                }
                return csvRow;
                }));
    };

    const handlePDFExport = (event) => {
        console.log('PDF Export');
        exportAsPDF(
            'List of Receipt Voucher',
            columns
            .filter(col => col.headerName !== 'ROW_ACTIONS')
            .map(col=>({header: col.headerName, dataKey: col.fieldName })),
            data.records.map(r => ({
                entity_name: r.entity_name,
                address: r.address, 
                phone_number:r.phone_number,
                mobile_number:r.mobile_number,
                status:r.status
            })),
            'ReceiptVoucher.pdf'
        );
    };

    useEffect(() => {

        getAllReceiptVouchers(cookies)
        .then( salesRepList => {
            const tableData = salesRepList.salesrep_data
            .map(salesrep => ({
                entity_name: salesrep.entity_name,
                address: `${salesrep.address_1},\n${salesrep.address_2},\n${salesrep.address_3}`,
                phone_number:salesrep.phone_number,
                mobile_number:salesrep.mobile_number,
                status:salesrep.status,
                id: salesrep.id,    
            }));

            setData({
                total: data.total,
                records: tableData
            });
            setIsLoading(false);
        });
        }, [refreshKey]);
    
    return (

        <div id="outer-container"  className="App" > 
            <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} />
            <div id="page-wrap">
            <ListFormPageHeader module="ACCOUNTS" title="List of Receipt Voucher" formLink="/ReceiptVoucher" addNewLabel="New Receipt Voucher" />
            <div className="container item-list-table-container">
                <div className="table-responsive">
                <ReactTableWrapper
                            title='List of Receipt Voucher'
                            columns={columns}
                            data={data.records}
                            onRowEdit={onEditReceiptVoucher}
                            onRowDelete={onDeleteReceiptVoucher}
                            onCSVExport={handleCSVExport}
                            onPDFExport={handlePDFExport}
                            isLoading={isLoading}
                        />
                </div>
                </div> 


            </div>
</div>

        
    );

}



export default ReceiptVoucherTable;